/**
 * Кампания и место игрока до аутентификации.
 *
 * Регистрация мастера, приглашения и места — фаза 3 (D8). Пока их нет,
 * взять кампанию неоткуда: идентификаторы приходят в адресной строке,
 * как в ссылке-приглашении, которой они станут. Это заглушка, и она
 * именно так и называется — «сессия», а не «профиль»: профиль появится
 * вместе с регистрацией и заменит этот файл целиком.
 *
 * Без параметров приложение открывается пустым списком, а не падает:
 * каркас должен показываться и до того, как появятся кампании.
 */

export type Session = {
  readonly campaignId: string | null
  readonly seatId: string | null
  /**
   * Стартовый уровень кампании, за стол которой идут (D60).
   *
   * Приходит тем же путём, что и место: экран приглашения знает его
   * из предпросмотра и кладёт в адрес, а визард берёт умолчанием
   * поля. `null` — драфт без кампании либо прямой заход по адресу.
   */
  readonly startLevel: number | null
}

export function readSession(search: string): Session {
  const params = new URLSearchParams(search)
  const level = Number(params.get('level'))
  return {
    campaignId: params.get('campaign'),
    seatId: params.get('seat'),
    // Чужое число из адреса: не уровень, если не целое от 1 до 20.
    startLevel: Number.isInteger(level) && level >= 1 && level <= 20 ? level : null,
  }
}
